<template>
  <div
    class="banner-card"
    :class="[dataClass]">
      <div class="carousel carousel-slider" ref="carousel">
        
        
            <div class="carousel-item grey-text" v-for="(x, i) in dataSlides" :data-target="i" :key="i">
              <div class="carousel-content">
                <div class="img-ele" :style="[{backgroundImage:`url(${x.url})`}]"></div>
                       
              </div>
            </div>
        
      </div>
      <div class="slide-navigation">
          <button @click="$_sliderNav('prev')"
            class="btn-prev btn-floating btn-small z-depth-2 waves-effect white">
          <i class="indigo-text text-darken-2 material-icons-outlined">arrow_back</i>
        </button>
        <button @click="$_sliderNav('next')"
          class="btn-next btn-floating btn-small z-depth-2 waves-effect white">
          <i class="indigo-text text-darken-2 material-icons-outlined">arrow_forward</i>
        </button>
      </div>
   
  </div>
</template>

<script>
import M from 'materialize-css'
export default {
  name: 'customSlider',
  props: {
    dataSlides: {
      type: [Array, Boolean],
      required: true,
      default: false,
    },
    dataStyle: {
      type: Object,
      default: () => ({}),
    },
    dataClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      itemStyles: {
          backgroundColor: 'rgb(83,109, 254)',
          backgroundPosition: '20px 0px',
          backgroundRepeat: 'no-repeat'
        }
      ,
      dataSlidesz:[
        {
          id: 0,
          styles:{
            backgroundSize:'cover !important',
            backgroundColor: 'rgb(83, 109, 254)'
          },
          title: 'Risk Assessment Tool Guide',
          message: 'Assess the risk of a Category 5 hurricane to your home in 3 easy, guided steps.'
        },
        {
          id: 1,
          styles:{
            backgroundSize:'cover !important',
            backgroundColor: '#f44336'
          },
          title: 'About Your Home ',
          message: 'Get started by entering basic information about your home and its location. Upload  photos to support your selections'
        },
        {
          id: 2,
          styles:{
            backgroundColor: 'rgb(133, 178, 10)'
          },
          title: 'Complete the guided ',
          message: 'Complete the guided assessments to predict the level of impact to your home from the winds, flooding and water shortage under a Category 5 hurricane scenario. Calculate your home energy use to understand your carbon footprint. You can complete these assessments in any order you like.'
        },
        {
          id: 3,
          title: 'About Your Home ',
          styles:{
            backgroundColor: '#ffab00'
          },
          message: 'Put all your assessment results together in the assessment summary to identify the hazards that pose the greatest risk, the key weak points of your home and the priority home improvements you can make to reduce vulnerabilities and expected impacts.'
        },
      ],
      slider_options: {
      fullWidth: true,
      indicators: false,
      onCycleTo: (e) => {
  /*       let indexVal = parseInt(e.attributes['data-target'].value)
        this.$emit('currentIndex', e.attributes['data-target'].value)
        //  this.activeIndex = -1
        setTimeout(() => {
          this.activeIndex = indexVal
          this.itemStyles.backgroundColor =  this.dataSlides[indexVal].styles.backgroundColor 
        }, 300); */
        }
    },
      activeIndex:0,
      sliderInstance: null
    }
  },
  mounted() {
    this.$_initSlider()
  },
  methods: {
    $_openGuide(m) {
      this.$emit('event', m)
    },
    $_sliderNav (e) {
      e === 'next'
      ? this.sliderInstance.next()
      : this.sliderInstance.prev()
    },
    $_customTruncate () {
      
    },
    $_initSlider () {
      setTimeout(() => {
          this.sliderInstance = M.Carousel.init(
        this.$refs.carousel,
        this.slider_options
      )
      }, 100);
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-card {
  cursor: pointer;
  position: relative;
  border-radius: 16px;
  margin: 12px -2px 24px;
  min-height: 240px;
  height: 100%;
  overflow: hidden;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  .carousel-slider {
    height: 100% !important;
    min-height: 100% !important;
    .carousel-item  {
      height: 100% !important;
      min-height: 100% !important;
    }
  }
  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: .5s linear all;
  }
  .carousel-content  {
    position: relative;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    .img-ele {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-size: 100%;        
        background-repeat: no-repeat;
    }
    &.current-0 {
      .area-message {
        //width: calc(100% - 70px);
      }
    }
}
  .area-title {
    font-size: 22px;
    color: white;
  }
  .area-message {
    color: white;
    margin-bottom: 10px;
    max-height: 64px;
    overflow: hidden;
    position: relative;
 /*    &::after {
      content: '...';
      position: absolute;
      bottom:0;
      margin-left: 2px;
    } */
  }

 
  .slide-step-index {
    font-size: 18px;
    position: absolute;
    right: 16px;
    top: 16px;
    border-radius: 50%;
    border: 2px solid #536dfe;
    z-index: 9;
    width: 42px;
    color: #536dfe;
    height: 42px;
    text-align: center;
    line-height: 38px;
  }
  .button-area {
    position: absolute;
    bottom: 24px;
    left: 48px;
  }
  .slide-navigation {
    .btn-next {
      position: absolute;
      z-index: 9;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
    }
    .btn-prev {
      position: absolute;
      z-index: 9;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
    }
  }

}
</style>
